type EnvName = 'production' | 'staging' | 'development' | 'unknown';

const STYLES: Record<EnvName, { label: string; classes: string; dot: string }> = {
  production: {
    label: 'PRODUCTION',
    classes: 'bg-red-600/10 text-red-400 border-b border-red-600/30',
    dot: 'bg-red-500',
  },
  staging: {
    label: 'STAGING',
    classes: 'bg-amber-500/10 text-amber-400 border-b border-amber-500/30',
    dot: 'bg-amber-400',
  },
  development: {
    label: 'DEVELOPMENT',
    classes: 'bg-surface text-text-secondary border-b border-border',
    dot: 'bg-emerald-500',
  },
  unknown: {
    label: 'UNKNOWN',
    classes: 'bg-surface text-text-secondary border-b border-border',
    dot: 'bg-slate-400',
  },
};

function resolveEnv(): EnvName {
  // Resolve strictly from the explicit VITE_ENV build var. We intentionally do
  // NOT fall back to import.meta.env.MODE: Vite sets MODE to 'production' for
  // any production build, which would mislabel non-prod deployments as PRODUCTION.
  const raw = import.meta.env.VITE_ENV as string | undefined;
  if (raw === 'production' || raw === 'staging' || raw === 'development') {
    return raw;
  }
  return 'unknown';
}

export function EnvironmentBanner() {
  const env = resolveEnv();
  const style = STYLES[env];

  return (
    <div
      role="status"
      aria-label={`Connected to ${style.label} environment`}
      className={`flex items-center justify-center gap-2 px-4 py-1 text-xs font-medium tracking-wide ${style.classes}`}
    >
      <span aria-hidden="true" className={`inline-block w-2 h-2 rounded-full ${style.dot}`} />
      <span>{style.label}</span>
    </div>
  );
}
